var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 464,
    viewBox: "0 0 295 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_2864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 295,
    height: 464
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 464,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_2864)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -279.5,
    cy: -39.5,
    r: 575.5,
    fill: "#353A4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -278.604,
    cy: -38.6036,
    r: 503.787,
    fill: "#353A4D",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -278.604,
    cy: -38.6035,
    r: 407.87,
    fill: "#353A4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Left);
export default __webpack_public_path__ + "static/media/404-left.c85f4cc1ad3656316ae2d7382a7c22f6.svg";
export { ForwardRef as ReactComponent };